// Copyright (c) 2023 Ryan Piaskowy. All Rights Reserved.
import React, { useState } from "react";
import Select from "react-select";

// Generic searchable multi-select dropdown. Selections are combined with OR
// logic by the caller (an item matches if it has ANY of the selected values).
function MultiSelectFilter({ label, options, selected, onChange, placeholder }) {
  const [searchText, setSearchText] = useState("");

  const selectOptions = options
    .filter((option) => option && option.trim() !== "")
    .map((option) => ({ value: option, label: option }));

  const value = selected.map((item) => ({ value: item, label: item }));

  return (
    <div className="multi-select-filter">
      {label && <label className="multi-select-label">{label}</label>}
      <Select
        isMulti
        options={selectOptions}
        value={value}
        onChange={(chosen) => onChange((chosen || []).map((item) => item.value))}
        placeholder={placeholder || `Search ${label || "options"}...`}
        classNamePrefix="msf"
        // Keep the menu open across multiple selections so users can check
        // off several options in a row instead of having to reopen the
        // dropdown after each pick. It only closes when the user clicks away
        // or presses Escape (react-select's default blur/close behavior).
        closeMenuOnSelect={false}
        blurInputOnSelect={false}
        hideSelectedOptions={false}
        // react-select clears the typed search text whenever an option is
        // selected (it fires onInputChange("", { action: "set-value" })).
        // Controlling inputValue and ignoring that clear lets someone search
        // "over", then click every matching venue without retyping.
        inputValue={searchText}
        onInputChange={(newValue, actionMeta) => {
          if (actionMeta.action === "input-change") {
            setSearchText(newValue);
          }
        }}
      />
    </div>
  );
}

export default MultiSelectFilter;
